import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMessage, deleteMessage } from './data';

export const useCreateMessageMutation = ({
  campaignUuid,
  openMessageModal,
}) => {
  const queryClient = useQueryClient();

  const { mutate: createMessageMutation } = useMutation(createMessage, {
    onSuccess: ({ data: { message } }) => {
      queryClient.setQueryData(
        ['campaignData', campaignUuid],
        ({ campaign }) => {
          const updatedCampaignPosts = campaign.posts.map(post => {
            if (post.uuid === message.postUuid) {
              return { ...post, userCount: message.userCount, message };
            }
            return post;
          });

          return { campaign: { ...campaign, posts: updatedCampaignPosts } };
        },
      );

      if (openMessageModal) openMessageModal(true);
    },
  });

  return { createMessageMutation };
};

export const useDeleteMessageMutation = () => {
  const queryClient = useQueryClient();

  const { mutate: deleteMessageMutation } = useMutation(deleteMessage, {
    onSuccess: () => {
      queryClient.invalidateQueries(['campaignData']);
    },
  });

  return { deleteMessageMutation };
};
